import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { Error } from '../../models/error.model';
import { UuidResponse } from '../../models/uuid.model';
import { authToken } from '../../scripts/authentication.script';

export class ApiDigitalAuthUUID {
  static apiResponse: ApiResponse

  public static async getUuid(
    api_key: string,
    uuid: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let UuidResponseUser: UuidResponse | null = null
      let UuidResponseCompany: UuidResponse | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/uuid.user.data.json').then(response => { UuidResponseUser = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/uuid.company.data.json').then(response => { UuidResponseCompany = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (UuidResponseUser!.data.data.uuid === uuid || UuidResponseCompany!.data.data.uuid === uuid) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: (UuidResponseUser!.success === true && UuidResponseCompany!.success === true) ? (uuid === UuidResponseUser!.data.data.uuid) ? UuidResponseUser!.data : UuidResponseCompany!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/uuid/${uuid}`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.get(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data.success === true ? response.data.data : null
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.success === false ? error.response.data.error : null
        }
      })
    }

    return this.apiResponse
  }
}
